import { HomeApi } from '@/domains/home/apis/home-api';
import { injectService } from '@patsnap/tahiti-core';

export const useConversation = () => {
  const homeApiService = injectService<HomeApi>(HomeApi);

  const createConversation = async (content: string) => {
    const res = await homeApiService.createFmea({ content });
    if (res.fmea_id) {
      window.location.href = `/fmea/#/page/${res.fmea_id}`;
    }
  };

  return {
    createConversation,
  };
};
